// extracted by mini-css-extract-plugin
export default {"products":"XA-z","card":"YA-z","oosMessaging":"ZA-z"};